<script>
  import GeocodePage from './GeocodePage.svelte';
  import IssueSelect from './IssueSelect.svelte';
  import RepList from './RepList.svelte';
  import {
    geocoderResult,
    currentPage,
    household,
    laCounty,
    fetchFeature,
    fetchGardens,
    // fetchData,
    fetchIssue,
    fetchZones,
    more,
    issueChoices,
    zonesChoices,
    issues,
    zones,
    issueData,
    zonesData,
    tileData,
    staticMapURLsDict,
  } from '../stores.js';
  import { createStaticMapUrls } from './../staticmaps.js';
  import Photos from './Photos.svelte';
  import Logo from './Logo.svelte';
  import Blank from './Blank.svelte';
  import {__} from '../utils/i18n';

  let date = window.PUBDATE.replace(/-/g, '/');

  const views = [GeocodePage, IssueSelect, Blank, RepList];
  const bLabels = [__("Get Started"), __("Let's go!"), '', ''];
  const classes = ['landing', 'landing', 'loading', 'main'];

  // COMMENT LINE 37-42 OUT IF YOU NEED LANDING PAGE AND/OR NAV
  
  // import dev, {getit} from '../dev.svelte';
  // process.env.NODE_ENV === 'production'
  // ? ''
    // los angeles 
    // : getit("10075 Arleta Ave, Arleta, CA 91331");
    // los angeles
    // : getit("2666 cimarron st, los angeles Ca 90018");
    // santa clarita
    // : getit("27534 Falling Star Ln, Santa Clarita, CA 91350");
    // santa monica
    // : getit("617 Grant St, Santa Monica, CA 90405");
    // bellflower
    // : getit("14748 Ryon Ave, Bellflower, CA 90706");
    // burbank
    // : getit("436 Tufts Ave, Burbank, CA 91504");
    // la mirada
    // : getit("14957 San Feliciano Dr, La Mirada, CA 90638");
    // palmdale
    // : getit("37937 Stardust Pl, Palmdale, CA 93552");
    // bell
    // :getit("6613 Flora Ave, Bell, CA 90201");
    // unincorporated
    // :getit("1590 Allen Ave, Pasadena, CA 91104");
    // downey
    // :getit("8656 Muller St, Downey, CA 90241");
    // west hollywood
    // :getit("1042 Havenhurst Dr, West Hollywood, CA 90046");
    // west covina
    // :getit("232 S Butterfield Rd, West Covina, CA 91791");
    // sierra madre
    // :getit("321 E Highland Ave, Sierra Madre, CA 91024");
    // signal hill
    // :getit("2370 Stanley Ave, Signal Hill, CA 90755");
    // agoura hills
    // :getit("29461 Quail Run Dr, Agoura Hills, CA 91301");
    // walnut
    // :getit("721 Lone Eagle Rd, Walnut, CA 91789");
    // torrance
    // :getit("2717 W Carson St, Torrance, CA 90503");
    // carson
    // :getit("22123 Ravenna Ave, Carson, CA 90745");

  const toIssues = () => {
    let lacTest = $geocoderResult.context
      .map((i) => i.text)
      .includes('Los Angeles County');
    // error on places and poi
    if (
      !$geocoderResult.id.includes('address') ||
      $geocoderResult.properties.accuracy.includes('street')
    ) {
      // console.log("it's a place", $household)
      $household = false;
      // console.log($household, $more)
    } else if (!lacTest) {
      $laCounty = false;
    } else {
      currentPage.set(1);
    }
  };

  const toRepsList = () => {
    let feedbackform = document.getElementById('feedback_form');

    feedbackform.classList.remove('show');

    // const promise1 = fetchData($geocoderResult);
    const promise1 = fetchFeature($geocoderResult);
    const promise2 = fetchGardens($geocoderResult);
    const promise3 = fetchIssue();
    const promise4 = fetchZones();

    currentPage.set(2);
    Promise.all([promise1, promise2, promise3, promise4]).then((values) => {
      issueChoices.set($issueData.filter((d) => {return $issues.includes(d.issue);}));
      //console.log("first issue store", $issues)
      zonesChoices.set($zonesData);

      // console.log("promised",values)
      // console.log("alltheissues", $issueData)
      // let mergedDivisions= $tileData;
      // parsedDivisions.set(mergedDivisions);
      $staticMapURLsDict = createStaticMapUrls($geocoderResult, $tileData);
      currentPage.set(3);
    });

    // change the nav
    // hide the logo section
    let navLogo = document.querySelector('div.flag-wrapper');
    navLogo.classList.add('hidden');
    navLogo.setAttribute('aria-hidden', 'true');
    // show the issues nav
    let navIssues = document.querySelector('div.issues-nav');
    navIssues.classList.remove('hidden');
    navIssues.setAttribute('aria-hidden', 'false');
  };

  let enter = () => {
    if ($currentPage == 0) {
      toIssues();
    } else if ($currentPage == 1) {
      toRepsList();
    }
  };

  $: viewportComponent = views[$currentPage];
  $: buttonLabel = bLabels[$currentPage];
  $: className = classes[$currentPage];

  const randomIlloGenerator = () => {
    let randomNum = Math.floor(Math.random() * 5);
    let illoName;

    switch (randomNum) {
      case 0:
        illoName = 'gardening';
        break;
      case 1:
        illoName = 'bus';
        break;
      case 2:
        illoName = 'fruitvendor';
        break;
      case 3:
        illoName = 'blockparty';
        break;
      case 4:
        illoName = 'publiccomments';
        break;
      default:
        illoName = 'canvassing';
    }
    return illoName;
  };

</script>

{#if $currentPage < 2}
  <div class={className}>
    <Photos
      lookup={randomIlloGenerator()}
      className="lead spot"
      idName=""
      ariaHidden="false"
      lazyLoad="false"
    />
    <Photos
      lookup="landing_top"
      className="mobile-lead-top"
      idName=""
      ariaHidden="true"
      lazyLoad="false"
    />

    <div class="lead-in" aria-live="polite">
      <Logo />
      <svelte:component this={viewportComponent} />
    </div>
    <button
      on:click={enter}
      id="submit-button"
      class="action"
      class:invisible={$currentPage > 1}>{buttonLabel}</button
    >
    <Photos
      lookup="landing_bottom"
      className="mobile-lead-bottom"
      idName=""
      ariaHidden="true"
      lazyLoad="false"
    />
  </div>
{:else}
  <div class={className}>
    <svelte:component this={viewportComponent} />
    <button
      on:click={enter}
      id="submit-button"
      class="action"
      class:invisible={$currentPage > 1}>{buttonLabel}</button
    >
  </div>
{/if}
